export default __webpack_public_path__ + "static/share_bg-6a8990a060433e272eefad96b858d449.png";